import { FieldNames } from 'Constants/FieldNames'
import { BgClientInfoTranslate, BgRequestType, BgStatus } from 'Pages/ibro'
import { LimitSize } from 'Pages/ibro/limitRequests/components/LimitRequestEdit/LimitSize'
import { OrganizationInfo } from 'Pages/ibro/limitRequests/components/LimitRequestEdit/OrganizationInfo'
import { Documents } from '../components/LimitRequestEdit/Documents'

export enum LimitRequestNav {
	LIMIT_SIZE, // Размер лимита
	ORGANIZATION_INFO, // Информация об организации
	DOCUMENTS, // документы
}

export const LimitRequestTranslate = {
	[LimitRequestNav.LIMIT_SIZE]: 'Размер лимита',
	[LimitRequestNav.ORGANIZATION_INFO]: 'Информация об организации',
	[LimitRequestNav.DOCUMENTS]: 'Документы',
}

export const LimitRequestEditComponents = {
	[LimitRequestNav.LIMIT_SIZE]: LimitSize,
	[LimitRequestNav.ORGANIZATION_INFO]: OrganizationInfo,
	[LimitRequestNav.DOCUMENTS]: Documents,
}

export const getLimitNavTitle = (navItem: string, orgType: string) => {
	if (String(LimitRequestNav.ORGANIZATION_INFO) === navItem) return BgClientInfoTranslate[orgType]
	return LimitRequestTranslate[navItem]
}

export const LimitRequestTitleButton = {
	[BgStatus.NOVA]: 'broker.next',
	[BgStatus.CL_CHECKED]: 'broker.reg_order',
	[BgStatus.FILLING]: 'broker.send_sign_order',
}

export const STATUS_WITH_ALLOWED_SEND_LIMIT = [
	BgStatus.NOVA,
	BgStatus.CL_CHECKED,
	BgStatus.FILLING,
	BgStatus.REWORK,
]

export const fieldsByFormBlockLimit = {
	[LimitRequestNav.LIMIT_SIZE]: [FieldNames.AMOUNT],
	[LimitRequestNav.ORGANIZATION_INFO]: [
		FieldNames.FIO,
		FieldNames.OGRN,
		FieldNames.OKVEDANOVER,
		FieldNames.ADDRESSJUR,
		FieldNames.REGISTRATIONDATE,
		FieldNames.KPP,
		FieldNames.EMAIL,
		FieldNames.PHONE,
		FieldNames.AUTHPERSONCITIZENSHIP,
		FieldNames.AUTHPERSONDATE,
		FieldNames.AUTHPERSONPLACE,
		FieldNames.AUTHPASSPORT,
		FieldNames.AUTHPASSPORTSER,
		FieldNames.AUTHPASSPORTNUM,
		FieldNames.AUTHPASSPORTDATEGIVE,
		FieldNames.AUTHPASSPORTWHOGIVE,
		FieldNames.AUTHPASSPORTKOD,
		FieldNames.AUTHADDRESS,
		FieldNames.AUTHINN,
		FieldNames.AUTHPOSITION,
		FieldNames.ACTINGUNDER,
	],
	[LimitRequestNav.DOCUMENTS]: [
		FieldNames.ANKETAFSC,
		FieldNames.FINANCIALSTATEMENT,
		FieldNames.AGREEMENT,
		FieldNames.BENEFINFO,
		FieldNames.BIGDEALPROTOCOL,
		FieldNames.CHANGEDGUARANTEEBLANK,
		FieldNames.DEBTLETTER,
		FieldNames.EGRUL,
		FieldNames.FINANCIALSTATEMENT,
		FieldNames.GENDIRSCAN,
		FieldNames.GUARANTEEBLANK,
		FieldNames.IPSCAN,
		FieldNames.PROCURATORY,
		FieldNames.PROTOCOLGENDIRSCAN,
		FieldNames.NEWGUARANTEEBLANK,
		FieldNames.OFERTA,
		FieldNames.USTAV,
		FieldNames.STATEMENTCKR,
		FieldNames.MANAGERGUARANTEEBLANK,
		FieldNames.GUARANTEEBLANK,
		FieldNames.PAYMENTTEMPLATE,
		FieldNames.BANKNEWGUARANTEEBLANK,
	],
}

export const astMessageTitleByStatus = {
	[BgRequestType.CHECK_LIMIT]: 'Отказ установки лимита',
}

export const limitRequestAmountLength = 10
